import { useState } from 'react';
import useDebounce from 'Hooks/useDebounce';

export default function useSearch({
  onSearchExit,
  onSearchValueEmpty,
  onSearch,
  onSearchFailure,
}) {
  const [searchText, setSearchText] = useState('');
  const [searching, setSearching] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSearchEnter = () => {
    setSearching(true);
  };

  const handleSearchExit = () => {
    // This needs to run after the selection occurs, which isn't async and takes a small amount of time. setTimeout() works, but isn't ideal
    setTimeout(() => {
      setSearching(false);
      setSearchText('');
      onSearchExit();
    }, 200);
  };

  const search = async (searchValue) => {
    if (!searchValue?.trim()) {
      onSearchValueEmpty();
      return;
    }
    setLoading(true);
    try {
      await onSearch(searchValue);
    } catch (e) {
      onSearchFailure(searchValue);
    }
    setLoading(false);
  };

  const searchDebounced = useDebounce(search, 500);

  return {
    searchText,
    setSearchText,
    searching,
    loading,
    handleSearchExit,
    handleSearchEnter,
    searchDebounced,
  };
}
